// extracted by mini-css-extract-plugin
module.exports = {"row":"Row_row__iJ2ja"};